const IMPRESSION_EVENT_NAME = 'experiment_impression'
const PLATFORM = 'web'

/**
 * A/B テストの露出（impression）を dataLayer に送る。
 *
 * @param {Object|null|undefined} assignment AbTesting::Assignment#impression_attributes。
 *   未割り当ての場合は null / undefined。
 * @param {string} assignment.experiment_id 実験キー。
 * @param {string} assignment.variant 割り当てられたバリアントの識別子。
 *
 * @example
 * trackAbTestImpression({
 *   experiment_id: 'example_experiment',
 *   variant: 'B'
 * })
 */
export function trackAbTestImpression(assignment) {
  if (!assignment?.experiment_id || !assignment?.variant) return
  if (typeof window === 'undefined') return

  const storageKey = `${IMPRESSION_EVENT_NAME}:${assignment.experiment_id}:${assignment.variant}`

  try {
    if (window.localStorage.getItem(storageKey)) return
  } catch {
    // localStorage が利用できない場合も露出イベントは送信する
  }

  try {
    if (typeof window.dataLayer?.push !== 'function') return

    window.dataLayer.push({
      event: IMPRESSION_EVENT_NAME,
      experiment_id: assignment.experiment_id,
      variant: assignment.variant,
      platform: PLATFORM
    })
  } catch {
    // 計測の失敗によって画面の処理を停止させない
    return
  }

  try {
    window.localStorage.setItem(storageKey, '1')
  } catch {
    // localStorage が利用できない環境では、送信済み状態を保存しない
  }
}
